import { useState } from "react";
import { GitBranch, LockKeyhole, LogOut, UserRoundCog } from "lucide-react";
import { TouchSheet } from "./TouchSheet";
import "./operator-header-menu.css";

export function OperatorHeaderMenu({ name, connection, onLock, onActions, onLogout }: {
  name: string; connection: string; onLock?: () => Promise<void>; onActions?: () => void; onLogout: () => Promise<void>;
}) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function perform(action: () => Promise<void>) {
    if (busy) return;
    setBusy(true); setError("");
    try { await action(); setOpen(false); }
    catch (cause) { setError(cause instanceof Error ? cause.message : "İşlem tamamlanamadı. Yeniden deneyin."); }
    finally { setBusy(false); }
  }
  return <span className="operator-header-menu-access">
    <button type="button" className="operator-header-menu-trigger" aria-label={`Operatör menüsü: ${name}`} aria-haspopup="dialog" aria-expanded={open} onClick={() => { setError(""); setOpen(true); }}><UserRoundCog size={20} aria-hidden="true"/><span>Operatör</span></button>
    {open ? <TouchSheet title="Operatör" variant="operator-menu" close={() => setOpen(false)} closeDisabled={busy}>
      <div className="operator-header-menu-body">
        <div className="operator-header-menu-person"><strong>{name}</strong><small>{connection}</small></div>
        {onActions ? <button type="button" disabled={busy} onClick={() => { setOpen(false); onActions(); }}><GitBranch size={20} aria-hidden="true"/>İş emri ve operatör işlemleri</button> : null}
        {onLock ? <button type="button" disabled={busy} onClick={() => void perform(onLock)}><LockKeyhole size={20} aria-hidden="true"/>Ekranı kilitle</button> : null}
        <button type="button" disabled={busy} onClick={() => void perform(onLogout)}><LogOut size={20} aria-hidden="true"/>Çıkış yap</button>
        {error ? <p role="alert">{error}</p> : null}
      </div>
    </TouchSheet> : null}
  </span>;
}
